import { useIntl } from 'react-intl';

import { ExportDownloadModal } from '@verantos-dev/core-utils';

import type { AnalysisDownloadModalProps } from '../types';

export const AnalysisDownloadModal = ({ onClose, download }: AnalysisDownloadModalProps) => {
  const { formatMessage } = useIntl();

  return (
    <ExportDownloadModal
      id="analysis-download-modal"
      download={download}
      onClose={onClose}
      messages={{
        title: formatMessage({ id: 'analysisDetail.downloadModal.title' }),
        loadingTitle: formatMessage({ id: 'analysisDetail.downloadModal.loadingTitle' }),
        loadingText: formatMessage({ id: 'analysisDetail.downloadModal.loadingText' }),
        errorTitle: formatMessage({ id: 'analysisDetail.downloadModal.errorTitle' }),
        errorText: formatMessage({ id: 'analysisDetail.downloadModal.errorText' }),
        retryButtonLabel: formatMessage({ id: 'analysisDetail.downloadModal.retryButton' }),
      }}
    />
  );
};
